import styled from 'styled-components';

const StyledModalWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 20;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.9);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

export { StyledModalWrapper };
